// extracted by mini-css-extract-plugin
export default {"status":"certificates_status__1yn-p","pass":"certificates_pass__PlKYP","fail":"certificates_fail__3iZCU","button":"certificates_button__B0PDg"};